'use client'

import { useCurrency } from '@repo/ui'
import { useEffect, useState } from 'react'
import ExperienceImgHeader from '../experienceImg-header'

export default function CurrencyAwareExperienceImgHeader({
  name,
  amount,
  time,
  className,
}: {
  name: string
  amount: string
  time: string
  className: string
}) {
  const { currency, isHydrated } = useCurrency()
  const [mounted, setMounted] = useState(false)

  // Prevent hydration mismatch by only showing dynamic layout after mount
  useEffect(() => {
    setMounted(true)
  }, [])

  // Always use horizontal layout until fully mounted and hydrated
  const layout =
    mounted && isHydrated && currency === 'EGP' ? 'vertical' : 'horizontal'

  return (
    <ExperienceImgHeader
      name={name}
      amount={amount}
      time={time}
      className={className}
      layout={layout}
    />
  )
}
